module.exports = __webpack_public_path__ + "img/logo.2b1ce69e.svg";